/**
 * Fetch the value of a query string item by name, with an optional URL
 * @param {string} key the query string key
 * @param {string} url the location bar address
 */
export const getParameterByName = (key: string, url?: string) => {
    if (!url) {
        url = window.location.href;
    }

    key = key.replace(/[[\]]/g, '\\$&');

    const regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) {
        return null;
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/**
 * Set or update a local storage item
 * @param {string} key the local storage key to set
 * @param {string} value the value to assign to that key
 */
const setLocalStorage = (key, value) => {
    if (key === 'session_id') {
        sessionStorage.setItem(key, value);
    }
};

/**
 * Take the query strings that statflo-webapp delivers and set them to local storage. If successful, return the value from the selected query string.
 * @param {string} key The part of the query string you want to interpret
 * @returns {string}
 */
const getQueryStringKey = (key) => {
    const queryValue = getParameterByName(key);

    if (queryValue) {
        setLocalStorage(key, queryValue);

        return queryValue;
    }

    const sessionValue = sessionStorage.getItem(key);

    if (sessionValue) {
        return sessionValue;
    }

    return null;
};

export default getQueryStringKey;



// WEBPACK FOOTER //
// ./src/helpers/getQueryStringKey.tsx